import { AppState } from "../../../redux-configuration/AppState";

export const addProductLoadingSelector = (appState: AppState): boolean => appState.ecommerce.addProduct.loading
export const addProductErrorSelector = (appState: AppState): string | undefined => appState.ecommerce.addProduct.error
export const addProductSuccessSelector = (appState: AppState): boolean | undefined => appState.ecommerce.addProduct.success
